import { ValueType } from '@convergence/types';
import { useCallback, useEffect } from 'react';
import { Button } from '@convergence/components';
import { deepClone } from '../util';
import {
  InputValidationError,
  validateInput
} from '../../../lib/validate-analysis-input';
import { useStateLocalStorage } from '../../../hooks/useStateLocalStorage';
import { AnalysisInputRoot } from './analysis-root-input';
import { useSearchParams } from 'react-router-dom';
import { useAnalysisQuery } from '../../../api/queries/analysis';

export type AnalysisInputMap = Record<
  number,
  {
    schema: ValueType;
    name: string;
    valueSchemaId: number;
    errors: { keyPath: string[]; message: string }[];
  }
>;

export type AnalysisInputProps = {
  onSubmit: (value: AnalysisInputMap) => void;
  inputs: {
    name: string;
    id: number;
    valueSchema: {
      id: number;
      name: string;
      schema: ValueType;
    };
  }[];
};

function getInputMap(inputs: AnalysisInputProps['inputs']) {
  return inputs.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.id]: {
        schema: cur.valueSchema.schema,
        valueSchemaId: cur.valueSchema.id,
        name: cur.name,
        errors: []
      }
    };
  }, {} as AnalysisInputMap);
}

export function AnalysisInputs({ inputs, onSubmit }: AnalysisInputProps) {
  console.log('analysisinputsrender');
  const [values, setValues] = useStateLocalStorage<AnalysisInputMap>(
    'analysis-input',
    getInputMap(inputs)
  );
  const [params, setSearchParams] = useSearchParams();

  const prefill = params.get('prefill');

  const prefillAnalysisQuery = useAnalysisQuery(prefill ?? undefined);
  console.log({ prefill, prefillAnalysisQueryData: prefillAnalysisQuery.data });

  useEffect(() => {
    const inputMap = getInputMap(inputs);
    console.log({
      inputs,
      prefillAnalysisQueryData: prefillAnalysisQuery.data
    });
    const prefillData = prefillAnalysisQuery.data?.output;
    if (!prefillData) {
      setValues(inputMap);
      return;
    }

    Object.entries(inputMap).forEach(([id, { name, valueSchemaId }]) => {
      console.log(
        `Checking input ${id} with name ${name} and valueSchemaId ${valueSchemaId} against prefill data`
      );
      for (const [key, value] of Object.entries(prefillData)) {
        const prefillValueSchemaId = (value as { valueSchemaId: number })
          .valueSchemaId;
        if (prefillValueSchemaId === valueSchemaId) {
          console.log(
            `Prefilling input ${id} with value from prefill data with matching valueSchemaId ${valueSchemaId}`
          );
          inputMap[+id] = {
            ...inputMap[+id]!,
            schema: (value as { value: ValueType; valueSchemaId: number })
              .value,
            errors: []
          };
        }
      }
    });
    setValues(inputMap);
  }, [inputs, prefillAnalysisQuery.data]);

  const handleSubmit = useCallback(() => {
    let clone = deepClone(values);

    Object.entries(values).map(([idString, { schema }]) => {
      const id = +idString;
      try {
        validateInput(schema);
        clone = {
          ...clone,
          [id]: { ...clone[id]!, errors: [] }
        };
        onSubmit(clone);
      } catch (err) {
        if (err instanceof InputValidationError) {
          clone = {
            ...clone,
            [id]: {
              ...clone[id]!,
              errors: [{ message: err.message, keyPath: err.path }]
            }
          };
        } else {
          throw new Error(`Unrecognized error: ${err}`);
        }
      }
    });
    setValues(clone);
  }, [values, onSubmit]);

  return (
    <div>
      {Object.entries(values).map(([id, { schema, name, errors }]) => (
        <AnalysisInputRoot
          key={`analysis-input-${id}-${name}`}
          analysisSchemaId={+id}
          value={schema}
          name={name}
          errors={errors}
          onChange={(v) => {
            setValues((old) => {
              return {
                ...old,
                [id]: { ...old[+id], schema: v }
              };
            });
          }}
        />
      ))}
      <Button onClick={() => handleSubmit()}>Launch</Button>
    </div>
  );
}
